/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { useQuery } from '@apollo/client';
import MBPLogger from '@module-logger/mbp';
import {
    object, shape, string,
} from 'prop-types';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';

import { GRAPHQL_ENV } from '../../../gql';
import HomePageSkeleton from '../GraphqlSkeletonComponents/HomePageSkeleton';
import GraphqlClubPageBody from './GraphqlClubPageBody';

import { coreBrowsingPageViewSuccessTest } from '../../../helpers/tracking/common/commonTrackingHelpers';
import withPageView from '../../../helpers/tracking/hocs/withPageView';
import { getBrand } from '../../../../state/ducks/App/ducks/Brand/Brand-Selectors';
import GraphqlSeoHeadTags from '../GraphqlCommonComponents/GraphqlSeoHeadTags/GraphqlSeoHeadTags';
import GraphqlClubPageStyle from './style/GraphqlClubPageStyle';
import findContentWithRefs from '../../../gql/queries/findContentWithRefs';

const styles = (theme) => GraphqlClubPageStyle(theme);

const GraphqlClubPage = ({
    classes, page, brand,
}) => {
    if (!page) return null;

    const findContentOptions = {
        brand: brand['domain-name'],
        contentType: page.contentType,
        includeRefs: JSON.stringify(['page_blocks.club_group.reference', 'page_blocks.subcollection.reference']),
        locale: 'en-us',
    };
    const CLUBPAGE_QUERY = findContentWithRefs(findContentOptions);
    const { data, loading, error } = useQuery(CLUBPAGE_QUERY);

    if (loading) {
        return <HomePageSkeleton />; // skeleton component
    }

    if (error) {
        MBPLogger.logError({
            appName: process.env.npm_package_name,
            query: CLUBPAGE_QUERY,
            component: 'GraphqlClubPage.js',
            message: `Error loading data for "${page.path}" type "${page.contentType}"`,
            env: GRAPHQL_ENV,
            error,
        });
        return null;
    }

    if (!data?.findContent?.content) {
        MBPLogger.logWarning({
            appName: process.env.npm_package_name,
            query: CLUBPAGE_QUERY,
            component: 'GraphqlClubPage.js',
            message: `No content returned for "${page.path}" type "${page.contentType}"`,
            env: GRAPHQL_ENV,
        });
        return null;
    }

    const entries = data.findContent.content?.entries[0] || [];
    const SEO = data.findContent.content?.entries[0]?.seo || {};
    return (
        <>
            <GraphqlSeoHeadTags seoData={SEO} />
            <div className={classes.clubLander}>
                <GraphqlClubPageBody
                    blocks={entries}
                />
            </div>
        </>
    );
};

GraphqlClubPage.propTypes = {
    classes: object.isRequired,
    page: shape({
        contentType: string.isRequired,
        path: string.isRequired,
    }).isRequired,
    brand: object.isRequired,
};

const mapStateToProps = (state) => ({
    brand: getBrand(state),
});

const enhance = compose(
    withRouter,
    connect(mapStateToProps),
    withPageView({
        pageViewSuccessTest: coreBrowsingPageViewSuccessTest,
    }),
);

export default enhance(withStyles(styles)(GraphqlClubPage));
